import api from './api';

// W7 ops widget — Backend admin health detail.
// Backend endpoint: GET /api/v1/admin/health (HealthController.cc)
// Distinto do público /healthz e /readyz — esse exige SUPER_ADMIN.

export type HealthStatus = 'ok' | 'degraded';

export interface BackendHealth {
  status: HealthStatus;
  service: string;            // "oraculo-api"
  version_build_time: string; // ex: "May 14 2026 20:30:00"
  uptime_seconds: number;
  db: string;                 // "ready" | "error: ..."
  r2_configured: boolean;
  r2_bucket?: string;
}

export async function getBackendHealth(): Promise<BackendHealth> {
  // Backend retorna 503 em degraded mas com mesmo shape — interceptor 401 não toca.
  // Tratamos 503 como resposta válida no .catch do caller (status 5xx levanta).
  try {
    const resp = await api.get<BackendHealth>('/admin/health');
    return resp.data;
  } catch (e: unknown) {
    // axios joga em 503. Tenta extrair o body do erro pra preservar shape.
    const err = e as { response?: { data?: BackendHealth } };
    if (err?.response?.data?.service === 'oraculo-api') {
      return err.response.data;
    }
    throw e;
  }
}
